









import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class GlobalLoading extends Vue {
  private get opened(): boolean {
    return this.$store.state.globalLoading.opened;
  }
}
